import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { RxCross2 } from "react-icons/rx";
import Swal from "sweetalert2";
import { Typeahead } from "react-bootstrap-typeahead";

import { FaArrowLeft } from "react-icons/fa";
import { useSelector } from "react-redux";
import { valueOf } from "../../../../assets/plugins/moment/src/lib/moment/to-type";
import apiInstance from "../../../../Utils/api";
import BASE_API_URL from "../../../../api/api";
const Top = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 20px 30px;
`;

const Center = styled.div`
  flex: 1;
  display: inline;
  text-align: center;
`;

const Button = styled.button`
  background: rgb(0, 7, 51);
  color: white;
  justify-content: center;
  padding: 5px 30px;
  border: none;
  border-radius: 10px;
  margin-top: 20px;
`;

const Title = styled.h5`
  font-weight: bold;
  margin-top: 10px;
`;
const Div = styled.div``;
const Label = styled.label``;
const Input = styled.input`
  width: 100%;
`;
const Span = styled.span`
  color: red;
`;
const Textarea = styled.textarea``;

const Select = styled.select`
  padding: 5px 7px;
  border-radius: 5px;
`;
const Option = styled.option``;

const Table = styled.table``;
const Thead = styled.thead``;
const Tbody = styled.tbody``;
const Tr = styled.tr`
  text-align: center;
`;
const Th = styled.th`
  font-size: 15px;
`;
const Td = styled.td`
  font-size: 14px;
`;

const Update2 = () => {

  const [generalList, setGeneralList] = useState([]);
  const [isGenItem, setIsGenItem] = useState(false);
  const [generalSelection, setGeneralSelection] = useState([]);
  //Gen
  const [tableGenData, setTableGenData] = useState([]);
  const [selectGenOption, setSelectGenOption] = useState({
    id: "",
    name: "",
  });
  const [doctors, setDoctors] = useState([]);
  const [tName, setTName] = useState([]);
  const [therapists, setTherapists] = useState([]);
  const [procedures, setProcedures] = useState([]);
  const [machines, setMachines] = useState([]);
  const [accessories, setAccessories] = useState([]);
  const [medicineList, setMedicineList] = useState([]);
  const [items, setItems] = useState([]);
  const [isItem, setIsItem] = useState(false);
  const [id, setId] = useState("");
  const [accitems, setAccItems] = useState([]);
  const [isAccItem, setIsAccItem] = useState(false);
  const [accid, setAccId] = useState("");
  const [macitems, setMacItems] = useState([]);
  const [isMacItem, setIsMacItem] = useState(false);
  const [medItems, setMedItems] = useState([]);
  const [isMedItem, setIsMedItem] = useState(false);
  const [qty, setQty] = useState("");

  const [macid, setMacId] = useState("");
  const [totalPrice, setTotalPrice] = useState("");
  const [percent, setPercent] = useState("");
  const [sellPrice, setSellPrice] = useState("");
  const [description, setDescription] = useState("");
  const [doctorname, setDoctorName] = useState("");
  const [therapistname, setTherapistName] = useState("");
  const [treatmenttime, setTreatmentTime] = useState("");
  const [treatmentCode, setTreatmentCode] = useState("");
  const [name, setName] = useState("");
  const [upProData, setUpProData] = useState([]);
  const [upMedData, setUpMedData] = useState([]);
  const [upProAcc, setUpProAcc] = useState([]);
  const [upMachine, setUpMachine] = useState([]);
  const [upGen, setUpGen] = useState([]);
  const [TCLtotalPrice, setTCLTotalPrice] = useState("");

  const [TCLsellPrice, setTCLSellPrice] = useState("");
  const [LMDsellPrice, setLMDSellPrice] = useState("");
  const [LMDtotalPrice, setLMDTotalPrice] = useState("");
  const [SCTotalPrice, setSCTotalPrice] = useState("");

  const [SCSellPrice, setSCSellPrice] = useState("");
  const [eightTotalPrice, setEightTotalPrice] = useState("");

  const [TggSellPrice, setTggSellPrice] = useState("");
  const [TggTotalPrice, setTggTotalPrice] = useState("");

  const [eightSellPrice, setEightSellPrice] = useState("");
  const [NptTotalPrice, setNptTotalPrice] = useState("");

  const [NptSellPrice, setNptSellPrice] = useState("");
  const [LSHTotalPrice, setLSHTotalPrice] = useState("");

  const [LSHSellPrice, setLSHSellPrice] = useState("");
  const [MDYTotalPrice, setMDYTotalPrice] = useState("");

  const [MDYSellPrice, setMDYSellPrice] = useState("");
  const [KTotalPrice, setKTotalPrice] = useState("");

  const [KSellPrice, setKSellPrice] = useState("");

  const [showPrice, setShowPrice] = useState(false);
  const [branchPrice, setBranchPrice] = useState([]);
  const [showHO, setShowHO] = useState(true);
  const [branchName, setBranchName] = useState("");
  const [branchList, setBranchList] = useState([]);
  const [branch, setBranch] = useState("");
  const [showEight, setShowEight] = useState(false);
  const [showNPT, setShowNPT] = useState(false);
  const [showMDY, setShowMDY] = useState(false);
  const [showLSH, setShowLSH] = useState(false);
  const [showK, setShowK] = useState(false);
  const [showSC, setShowSC] = useState(false);
  const [showTgg, setShowTgg] = useState(false);
  const [showLMD, setShowLMD] = useState(false);
  const [showTCLTotal, setShowTCLTotal] = useState(false);

  const [medSelection, setMedSelection] = useState([]);
  const [proMedSelection, setProMedSelection] = useState([]);
  const [accSelection, setAccSelection] = useState([]);
  const [machineSelection, setMachineSelection] = useState([]);

  const [upMedDataChange, setUpMedDataChange] = useState([]);
  //Pro Medicine
  const [tableProData, setTableProData] = useState([]);
  const [selectOption, setSelectOption] = useState({
    id: "",
    name: "",
  });

  //Medicine
  const [tableMedData, setTableMedData] = useState([]);
  const [selectMedOption, setSelectMedOption] = useState({
    id: "",
    name: "",
  });

  //Medicine
  const [tableProAccData, setTableProAccData] = useState([]);
  const [selectProAccOption, setSelectProAccOption] = useState({
    id: "",
    name: "",
  });

  //Machine
  const [tableMachineData, setTableMachineData] = useState([]);
  const [selectMacOption, setSelectMacOption] = useState({
    id: "",
    name: "",
  });

  const [unitID, setUnitID] = useState("");

  //NOTE To get two ID
  const Id = useLocation().pathname.split("/")[2];
  const TreatId = useLocation().pathname.split("/")[3];
  // console.log(TreatId,'Hello')

  //End

  //med remove
  const [upMedRemoveData, setUpMedRemoveData] = useState([]);

  const handleBranch = (id) => {
    setBranch(id);
    if (id == "6474394fdab649311f9fcc32") {
      setBranchName("SOK");
    } else {
      setBranchName(branchList.filter((el) => el._id === id)[0].name);
    }
    if (id == "6535f7fef68b0525e0eaf151") {
      setShowLMD(false);
      setShowEight(false);
      setShowHO(false);
      setShowPrice(false);
      setShowLSH(false);
      setShowNPT(false);
      setShowMDY(false);
      setShowK(false);
      setShowSC(true);
      setShowTgg(false);
    }
    if (id == "6535f811f68b0525e0eaf152") {
      setShowLMD(false);
      setShowEight(false);
      setShowHO(false);
      setShowPrice(false);
      setShowLSH(false);
      setShowNPT(false);
      setShowMDY(false);
      setShowK(false);
      setShowSC(false);
      setShowTgg(true);
    }

    if (id == "6474394fdab649311f9fcc32") {
      setShowLMD(false);
      setShowEight(false);
      setShowHO(true);
      setShowPrice(false);
      setShowLSH(false);
      setShowNPT(false);
      setShowMDY(false);
      setShowK(false);
      setShowSC(false);
      setShowTgg(false);
    }
    if (id == "64743985dab649311f9fcc33") {
      setShowLMD(false);
      setShowEight(true);
      setShowHO(false);
      setShowPrice(false);
      setShowLSH(false);
      setShowNPT(false);
      setShowMDY(false);
      setShowK(false);
      setShowSC(false);
      setShowTgg(false);
    }
    if (id == "64743991dab649311f9fcc34") {
      setShowLMD(false);
      setShowEight(false);
      setShowHO(false);
      setShowPrice(false);
      setShowLSH(false);
      setShowNPT(true);
      setShowMDY(false);
      setShowK(false);
      setShowSC(false);
      setShowTgg(false);
    }
    if (id == "6474399edab649311f9fcc35") {
      setShowLMD(false);
      setShowEight(false);
      setShowHO(false);
      setShowPrice(false);
      setShowLSH(true);
      setShowNPT(false);
      setShowMDY(false);
      setShowK(false);
      setShowSC(false);
      setShowTgg(false);
    }
    if (id == "647439aadab649311f9fcc36") {
      setShowLMD(false);
      setShowEight(false);
      setShowHO(false);
      setShowPrice(false);
      setShowLSH(false);
      setShowNPT(false);
      setShowMDY(true);
      setShowK(false);
      setShowSC(false);
      setShowTgg(false);
    }
    if (id == "649559535fc22f0e7f0884fe") {
      if (TCLtotalPrice) {
        setShowTCLTotal(false);
      }
      setShowLMD(false);
      setShowEight(false);
      setShowHO(false);
      setShowPrice(true);
      setShowLSH(false);
      setShowNPT(false);
      setShowMDY(false);
      setShowK(false);
      setShowSC(false);
      setShowTgg(false);
    }
    if (id == "64b6064a61cdd336e64f9300") {
      setShowEight(false);
      setShowHO(false);
      setShowPrice(false);
      setShowLSH(false);
      setShowNPT(false);
      setShowMDY(false);
      setShowK(true);
      setShowSC(false);
      setShowTgg(false);
      setShowLMD(false);
    }
    //LMD
    if (id == "675a5d8fb2a9c1d91266a144") {
      setShowEight(false);
      setShowHO(false);
      setShowPrice(false);
      setShowLSH(false);
      setShowNPT(false);
      setShowMDY(false);
      setShowK(false);
      setShowSC(false);
      setShowTgg(false);
      setShowLMD(true);
    }
  };

  useEffect(() => {
    const getMedicine = async () => {
      const res = await apiInstance.get("medicine-items");
      setMedicineList(res.data.list);
    };

    const getProcedures = async () => {
      const res = await apiInstance.get("procedure-items");
      setProcedures(res.data.list);
    };
    const getAccessories = async () => {
      const res = await apiInstance.get("accessory-items");
      // console.log(res.data.list, 'acc')
      setAccessories(res.data.list);
    };
    const getGeneral = async () => {
      const res = await apiInstance.get("general-items");
      // console.log(res.data.list, 'acc')
      setGeneralList(res.data.list);
    };
    // const getTreatment = async () => {
    //   const res = await api.get('treatment-list/' + Id)
    //   console.log(res.data, 'treatement')

    //   // setTName(res.data.data[0].name)
    //   // console.log(res.data.data[0].name)
    // }

    const getMachines = async () => {
      const res = await apiInstance.get("fixed-assets");
      setMachines(
        res.data.list.filter(
          (el) =>
            el.type == "Medical Equipment" ||
            el.type == "Surgery Equipment" ||
            el.type == "Medical Machinery",
        ),
      );
    };

    //  getTreatment()
    const getBranches = async () => {
      const res = await apiInstance.get("branches");
      setBranchList(res.data.list);
    };

    const getTreatment = async () => {
      try {
        const res = await apiInstance.get("treatment/" + Id);
        console.log(res.data.data[0], "treat up");
        setEightTotalPrice(res.data.data[0].EightMileEstimateTotalPrice);
        setPercent(res.data.data[0].discount);

        setTCLTotalPrice(res.data.data[0].TCLEstimateTotalPrice);

        setTCLSellPrice(
          res.data.data[0].TCLSellingPrice
            ? res.data.data[0].TCLSellingPrice
            : "",
        );

        setNptTotalPrice(res.data.data[0].NPTEstimateTotalPrice);
        setSCTotalPrice(res.data.data[0].SanChaungEstimateTotalPrice);
        setSCSellPrice(res.data.data[0].SanChaungSellingPrice);
        setTggTotalPrice(res.data.data[0].ThingangyunEstimateTotalPrice);
        setTggSellPrice(res.data.data[0].ThingangyunSellingPrice);
        setNptSellPrice(res.data.data[0].NPTSellingPrice);

        setEightSellPrice(res.data.data[0].EightMileSellingPrice);
        setMDYTotalPrice(res.data.data[0].MDYEstimateTotalPrice);

        setMDYSellPrice(res.data.data[0].MDYSellingPrice);
        setLSHTotalPrice(res.data.data[0].LSHEstimateTotalPrice);

        setLSHSellPrice(res.data.data[0].LSHSellingPrice);

        setKTotalPrice(res.data.data[0].KShoppingEstimateTotalPrice);

        setKSellPrice(res.data.data[0].KShoppingSellingPrice);
        setLMDSellPrice(res.data.data[0].LMDSellingPrice);
        setLMDTotalPrice(res.data.data[0].LMDEstimateTotalPrice);

        setSellPrice(res.data.data[0].sellingPrice);
        setTotalPrice(res.data.data[0].estimateTotalPrice);

        setUnitID(res.data.data[0]._id);

        setName(res.data.data[0].name);
        setTreatmentCode(res.data.data[0].treatmentCode);
        setTreatmentTime(res.data.data[0].treatmentTimes);

        setPercent(res.data.data[0].discount);
        setDescription(res.data.data[0].description);

        //NOTE For Meducine
        if (
          res.data.data[0].medicineLists !== null &&
          res.data.data[0].medicineLists.length > 0
        ) {
          const newData = res.data.data[0].medicineLists.map((data, index) => {
            return {
              id: index,
              name: data.item_id ? data.item_id.medicineItemName : "",
              item_id: data.item_id._id,
              quantity: data.quantity,
              perUsageQTY: data.perUsageQTY,
              unit: data.unit,
            };
          });
          // console.log(newData, 'meeeeeeed')
          setUpMedData(newData);
          setIsMedItem(true);
        }
        //NOTE For Procedure Medicine
        if (
          res.data.data[0].procedureMedicine !== null &&
          res.data.data[0].procedureMedicine.length > 0
        ) {
          const newData = res.data.data[0].procedureMedicine.map(
            (data, index) => {
              return {
                id: index,
                name: data.item_id ? data.item_id.procedureItemName : "",
                item_id: data.item_id._id,
                quantity: data.quantity,
                perUsageQTY: data.perUsageQTY,
                unit: data.unit,
              };
            },
          );
          setUpProData(newData);
          setIsItem(true);
        }
        //NOTE For Procedure Accessory
        if (
          res.data.data[0].procedureAccessory !== null &&
          res.data.data[0].procedureAccessory.length > 0
        ) {
          const newData = res.data.data[0].procedureAccessory.map(
            (data, index) => {
              return {
                id: index,
                name: data.item_id ? data.item_id.accessoryItemName : "",
                item_id: data.item_id._id,
                quantity: data.quantity,
                perUsageQTY: data.perUsageQTY,
                unit: data.unit,
              };
            },
          );
          setUpProAcc(newData);
          // console.log(newData, 'Pro Acc')
          setIsAccItem(true);
        }

        //NOTE For General Item
        if (
          res.data.data[0].general !== null &&
          res.data.data[0].general.length > 0
        ) {
          const newData = res.data.data[0].general.map((data, index) => {
            return {
              id: index,
              name: data.item_id ? data.item_id.accessoryItemName : "",
              item_id: data.item_id._id,
              quantity: data.quantity,
              perUsageQTY: data.perUsageQTY,
              unit: data.unit,
            };
          });
          setUpGen(newData);
          // console.log(newData, 'Pro Acc')
          setIsGenItem(true);
        }
        //NOTE For Machine
        if (
          res.data.data[0].machine !== null &&
          res.data.data[0].machine.length > 0
        ) {
          const newData = res.data.data[0].machine.map((data, index) => {
            return {
              id: index,
              name: data.item_id ? data.item_id.name : "",
              item_id: data.item_id._id,
              quantity: data.quantity,
              perUsageQTY: data.perUsageQTY,
              unit: data.unit,
            };
          });
          setUpMachine(newData);
          // console.log(newData, 'Mac Acc')
          setIsMacItem(true);
        }
      } catch (err) {
        alert(err.message);
      }
    };
    getTreatment();
    getGeneral();
    getBranches();

    getMedicine();

    // getTherapists()
    getProcedures();
    getAccessories();
    getMachines();
  }, []);

  const removeUpMedicine = (index) => {
    // if (upMedData.index !== index)
    // console.log(upMedData, 'UpMEDDATA')
    const temp = [...upMedData];
    // console.log(temp.splice(index, 1), 'list')
    // console.log(temp, 'TEMP')
    setUpMedData(temp);
    // }
  };
  // function findId(arr){
  //   return arr.id === id
  // }
  // const removeUpMedicine = id => {
  //   // make a separate copy of the array
  //   var index = upMedData.map(el => el.item_id === id).indexOf(id)
  //   // if (index !== -1) {
  //   //   upMedData.splice(index, 1)
  //   // }
  //   console.log(index, 'up med remove')
  // }
  // const removeUpMedicine = id => {
  //   setUpMedData({
  //     return upMedData.filter((_, i) => i !== id)
  // })
  //   setIsMedItem(true)
  // }

  const removeUpProcedure = (id) => {
    setUpProData(upProData.filter((el) => el.item_id != id));
  };

  const removeUpProAcc = (id) => {
    setUpProAcc(upProAcc.filter((el) => el.item_id != id));
  };

  const removeUpMac = (id) => {
    setUpMachine(upMachine.filter((el) => el.item_id != id));
  };

  //Start procedure medicine add row

  //NOTE Input Changes when input qty and per usage qty
  const handleProInputChange = (event, id, field) => {
    const newData = tableProData.map((data) => {
      if (data.id === id) {
        return { ...data, [field]: event.target.value };
      }
      return data;
    });
    // console.log(newData)
    setTableProData(newData);
  };
  const handleUpProInputChange = (event, id, field) => {
    // console.log(field, 'uppro')
    const newData = upProData.map((data) => {
      if (data.id === id) {
        return { ...data, [field]: event.target.value };
      }
      return data;
    });
    // console.log(newData)
    setUpProData(newData);
  };

  //NOTE to add row of Procedure Medicine
  const handleProAddRow = (id, name) => {
    // console.log(name, 'Pro name')
    setTableProData([
      ...tableProData,
      {
        id: tableProData.length + 1,
        name: name,
        item_id: id,
        quantity: "",
        perUsageQTY: "",
        unit: "",
      },
    ]);

    // console.log(proMedName, 'pro med')
    setIsItem(true);
  };

  //NOTE to get Id and Name of procedure medicine
  const handleProGet = (event) => {
    const { options, selectedIndex } = event.target;
    const selectedOption = options[selectedIndex];
    const id = selectedOption.getAttribute("data-id");

    const proName = selectedOption.getAttribute("data-name");
    setSelectOption({
      id: id,
      name: proName,
    });

    // const value = event.target.value
    // // Use the id, name, and value as needed
    // console.log('ID:', id)
    // console.log('Name:', proName)
    // console.log('Value:', value)
  };

  //NOTE to delete proecedure medicine
  const removeProcedure = (id) => {
    setTableProData(tableProData.filter((el) => el.item_id != id));
  };
  //End procedure medicine add row

  //General
  const handleGeneralInputChange = (event, id, field) => {
    const newData = tableGenData.map((data) => {
      if (data.id === id) {
        return { ...data, [field]: event.target.value };
      }
      return data;
    });
    console.log(newData);
    setTableGenData(newData);
  };

  const handleUpGeneralInputChange = (event, id, field) => {
    const newData = upGen.map((data) => {
      if (data.id === id) {
        return { ...data, [field]: event.target.value };
      }
      return data;
    });
    console.log(newData);
    setUpGen(newData);
  };
  //NOTE to add row of Procedure Medicine
  const handleGeneralAddRow = (id, name) => {
    // console.log(name, 'Pro name')
    setTableGenData([
      ...tableGenData,
      {
        id: tableGenData.length + 1,
        name: name,
        item_id: id,
        quantity: "",
        perUsageQTY: "",
      },
    ]);

    // console.log(proMedName, 'pro med')
    setIsGenItem(true);
  };

  //NOTE to get Id and Name of procedure medicine

  //NOTE to delete proecedure medicine
  const removeGeneral = (id) => {
    // console.log(id, 'gen')
    setTableGenData(tableGenData.filter((el, i) => el.id !== id));
  };
  const removeUpGeneral = (id) => {
    // console.log(id, 'gen')
    setUpGen(upGen.filter((el, i) => el.id !== id));
  };
  //Start procedure medicine add row

  //NOTE Input Changes when input qty and per usage qty
  const handleMachineInputChange = (event, id, field) => {
    const newData = tableMachineData.map((data) => {
      if (data.id === id) {
        return { ...data, [field]: event.target.value };
      }
      return data;
    });
    // console.log(newData, 'mac new data')
    setTableMachineData(newData);
  };

  const handleUpMachineInputChange = (event, id, field) => {
    // console.log(field, 'upmachin')
    const newData = upMachine.map((data) => {
      if (data.id === id) {
        return { ...data, [field]: event.target.value };
      }
      return data;
    });
    // console.log(newData, 'up med data')
    setUpMachine(newData);
  };

  //NOTE to add row of Procedure Medicine
  const handleMachineAddRow = (id, name) => {
    // console.log(name, 'Mac name')
    setTableMachineData([
      ...tableMachineData,
      {
        id: tableMachineData.length + 1,
        name: name,
        item_id: id,
        quantity: "",
        perUsageQTY: "",
        unit: "",
      },
    ]);

    // console.log(proMedName, 'pro med')
    setIsMacItem(true);
  };

  //NOTE to get Id and Name of procedure medicine
  const handleMacGet = (event) => {
    const { options, selectedIndex } = event.target;
    const selectedOption = options[selectedIndex];
    const id = selectedOption.getAttribute("data-id");

    const macName = selectedOption.getAttribute("data-name");
    setSelectMacOption({
      id: id,
      name: macName,
    });

    // const value = event.target.value
    // // Use the id, name, and value as needed
    // console.log('ID:', id)
    // console.log('Name:', proName)
    // console.log('Value:', value)
  };

  //NOTE to delete proecedure medicine
  const removeMac = (id) => {
    console.log(id, "Re Id");
    setTableMachineData(tableMachineData.filter((el) => el.id != id));
  };
  //End procedure medicine add row

  //Start Medicine add row
  //NOTE Input Changes when input qty and per usage qty
  const handleMedInputChange = (event, id, field) => {
    const newData = tableMedData.map((data) => {
      if (data.id === id) {
        return { ...data, [field]: event.target.value };
      }
      return data;
    });
    // console.log(newData, 'new med data')
    setTableMedData(newData);
  };

  const handleUpMedInputChange = (event, id, field) => {
    // console.log(field, 'upmed')
    const newData = upMedData.map((data) => {
      if (data.id === id) {
        return { ...data, [field]: event.target.value };
      }
      return data;
    });
    // console.log(newData, 'up med data')
    setUpMedData(newData);
  };

  //NOTE to add row of Procedure Medicine
  const handleMedAddRow = (id, name) => {
    // console.log(name, 'Med name')
    setTableMedData([
      ...tableMedData,
      {
        id: tableMedData.length + 1,
        name: name,
        item_id: id,
        quantity: "",
        perUsageQTY: "",
        unit: "",
      },
    ]);

    // console.log(proMedName, 'pro med')
    setIsMedItem(true);
  };

  //NOTE to get Id and Name of procedure medicine
  const handleMedGet = (event) => {
    const { options, selectedIndex } = event.target;
    const selectedOption = options[selectedIndex];
    const id = selectedOption.getAttribute("data-id");

    const medName = selectedOption.getAttribute("data-name");
    setSelectMedOption({
      id: id,
      name: medName,
    });

    // Use the id, name, and value as needed
    // console.log('ID:', id)
    // console.log('Name:', medName)
    // console.log('Value:', value)
  };

  //NOTE to delete proecedure medicine
  const removeMedicine = (id) => {
    setTableMedData(tableMedData.filter((el) => el.item_id != id));
  };

  //End Medicine add row

  //Start ProAccessory add row
  //NOTE Input Changes when input qty and per usage qty
  const handleProAccInputChange = (event, id, field) => {
    const newData = tableProAccData.map((data) => {
      if (data.id === id) {
        return { ...data, [field]: event.target.value };
      }
      return data;
    });
    // console.log(newData)
    setTableProAccData(newData);
  };

  const handleUpProAccInputChange = (event, id, field) => {
    const newData = upProAcc.map((data) => {
      if (data.id === id) {
        return { ...data, [field]: event.target.value };
      }
      return data;
    });
    // console.log(newData)
    setUpProAcc(newData);
  };

  //NOTE to add row of Procedure Medicine
  const handleProAccAddRow = (id, name) => {
    // console.log(name, 'proAcc name')
    setTableProAccData([
      ...tableProAccData,
      {
        id: tableProAccData.length + 1,
        name: name,
        item_id: id,
        quantity: "",
        perUsageQTY: "",
        unit: "",
      },
    ]);

    // console.log(proMedName, 'pro med')
    setIsAccItem(true);
  };

  //NOTE to get Id and Name of procedure medicine
  const handleProAccGet = (event) => {
    const { options, selectedIndex } = event.target;
    const selectedOption = options[selectedIndex];
    const id = selectedOption.getAttribute("data-id");

    const proAccName = selectedOption.getAttribute("data-name");
    setSelectProAccOption({
      id: id,
      name: proAccName,
    });

    const value = event.target.value;
    // Use the id, name, and value as needed
    console.log("ID:", id);
    console.log("Name:", proAccName);
    console.log("Value:", value);
  };

  //NOTE to delete proecedure medicine
  const removeProAcc = (id) => {
    setTableProAccData(tableProAccData.filter((el) => el.item_id != id));
  };

  const handlePercent = (event) => {
    setPercent(event);
    const res = (event / 100) * totalPrice;
    const final = totalPrice - res;

    setSellPrice(final);
    // console.log((event / 100) * totalPrice, 'per res')
  };

  //End Medicine add row

  const update = () => {
    // console.log(TreatId,'Treat ID')
    const data = {
      id: unitID,
      name: name,
      treatmentCode: treatmentCode,
      treatmentName: TreatId,
      treatmentTimes: treatmenttime,
      // relatedDoctor: doctorname,
      // medicineLists: tableMedData,
      // procedureMedicine: tableProData,
      // procedureAccessory: tableProAccData,
      // machine: macitems,
      estimateTotalPrice: totalPrice,
      discount: percent,
      sellingPrice: sellPrice,
      // TCLEstimateTotalPrice: TCLtotalPrice,
      // TCLSellingPrice: TCLsellPrice,
      description: description,
      status: true,
    };

    if (upProData) {
      data.procedureMedicine = [...upProData, ...tableProData];
    } else {
      data.procedureMedicine = tableProData;
    }

    if (upGen) {
      data.general = [...upGen, ...tableGenData];
    } else {
      data.general = tableGenData;
    }
    if (upMedData && tableMedData) {
      data.medicineLists = [...upMedData, ...tableMedData];
    } else {
      data.medicineLists = upMedData;
    }

    if (upProAcc) {
      data.procedureAccessory = [...upProAcc, ...tableProAccData];
    } else {
      data.procedureAccessory = tableProAccData;
    }

    if (upMachine) {
      data.machine = [...upMachine, ...tableMachineData];
    } else {
      data.machine = tableMachineData;
    }

    if (branch == "6535f7fef68b0525e0eaf151" || SCTotalPrice) {
      data.SanChaungEstimateTotalPrice = SCTotalPrice;
      data.SanChaungSellingPrice = SCSellPrice;
    }
    if (branch == "6535f811f68b0525e0eaf152" || TggTotalPrice) {
      data.ThingangyunEstimateTotalPrice = TggTotalPrice;
      data.ThingangyunSellingPrice = TggSellPrice;
    }

    if (branch == "6474394fdab649311f9fcc32" || totalPrice) {
      data.estimateTotalPrice = totalPrice;
      data.sellingPrice = sellPrice;
      data.discount = percent;
    }
    if (branch == "64743985dab649311f9fcc33" || eightTotalPrice) {
      data.EightMileEstimateTotalPrice = eightTotalPrice;
      data.EightMileSellingPrice = eightSellPrice;
    }

    if (branch == "64743991dab649311f9fcc34" || NptTotalPrice) {
      data.NPTEstimateTotalPrice = NptTotalPrice;
      data.NPTSellingPrice = NptSellPrice;
    }
    if (branch == "6474399edab649311f9fcc35" || LSHTotalPrice) {
      data.LSHEstimateTotalPrice = LSHTotalPrice;
      data.LSHSellingPrice = LSHSellPrice;
    }
    if (branch == "647439aadab649311f9fcc36" || MDYTotalPrice) {
      data.MDYEstimateTotalPrice = MDYTotalPrice;
      data.MDYSellingPrice = MDYSellPrice;
    }

    if (branch == "649559535fc22f0e7f0884fe" || TCLtotalPrice) {
      data.TCLEstimateTotalPrice = TCLtotalPrice;
      data.TCLSellingPrice = TCLsellPrice;
    }
    if (branch == "64b6064a61cdd336e64f9300" || KTotalPrice) {
      data.KEstimateTotalPrice = KTotalPrice;
      data.KSellingPrice = KSellPrice;
    }
    if (branch == "675a5d8fb2a9c1d91266a144" || LMDtotalPrice) {
      data.LMDEstimateTotalPrice = LMDtotalPrice;
      data.LMDSellingPrice = LMDsellPrice;
    }

    // alert(JSON.stringify(data))
    apiInstance
      .put("treatment", data)
      .then(function (response) {
        Swal.fire({
          title: "Successful!",
          text: "Successfully Updated",
          icon: "success",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });
        window.location.reload();
      })
      .catch(function (err) {
        Swal.fire({
          title: "Something Wrong!",
          text: "Try again, Please.",
          icon: "warning",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });
      });
  };

  return (
    <>

        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-12">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to={"/checkUnit/" + TreatId}>
                        <i>
                          <FaArrowLeft />
                        </i>
                      </Link>
                    </li>
                    <li className="breadcrumb-item active">Treatment Create</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <section className="content">
            <div className="container-fluid">
              <div className="card-body row border border-dark">
                <h5>Unit Update</h5>
                <div className="offset-2 col-8 py-5">
                  <div className="row">
                    <div className="col-4 form-group ">
                      <Label>
                        Treatment Unit Name<Span>*</Span>
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        defaultValue={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </div>
                    <div className="col-4 form-group">
                      <Label>
                        Treatment Unit Code<Span>*</Span>
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        defaultValue={treatmentCode}
                        onChange={(e) => setTreatmentCode(e.target.value)}
                      />
                    </div>
                    <div className="col-4 form-group">
                      <Label>
                        Treatment Times<Span>*</Span>
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        defaultValue={treatmenttime}
                        onChange={(e) => setTreatmentTime(e.target.value)}
                      />
                    </div>

                    <div className="col-6 form-group mt-3">
                      <Label>Medicine</Label>
                      <Typeahead
                        id="basic-typeahead-single"
                        labelKey="medicineItemName"
                        onChange={setMedSelection}
                        options={medicineList}
                        placeholder="Choose a medicine items..."
                        selected={medSelection}
                      />
                    </div>
                    <div className="col-3 mt-4">
                      <Button
                        onClick={(e) =>
                          handleMedAddRow(
                            medSelection[0]._id,
                            medSelection[0].medicineItemName,
                          )
                        }
                      >
                        Add
                      </Button>
                    </div>
                    <div className="col-12 mt-3">
                      <Table className="table table-striped">
                        <Thead>
                          <Tr>
                            {/* <Th>No.</Th> */}
                            <Th>Item Name</Th>
                            <Th>Qty</Th>

                            <Th>Per Usage Qty</Th>

                            <Th>Unit</Th>
                          </Tr>
                        </Thead>

                        <Tbody>
                          {isMedItem &&
                            upMedData.map((item, index) => (
                              <Tr>
                                {/* {console.log(item, 'State Check')} */}
                                <Td>{item.name}</Td>
                                <Td>
                                  <input
                                    type="number"
                                    // defaultValue={procedure.qty}
                                    value={item.quantity}
                                    onChange={(event) =>
                                      handleUpMedInputChange(
                                        event,
                                        item.id,
                                        "quantity",
                                      )
                                    }
                                    className="form-control"
                                  />
                                </Td>
                                {/* <Td>{procedure.purchasePrice}</Td> */}
                                <Td>
                                  <input
                                    type="number"
                                    value={item.perUsageQTY}
                                    onChange={(event) =>
                                      handleUpMedInputChange(
                                        event,
                                        item.id,
                                        "perUsageQTY",
                                      )
                                    }
                                    className="form-control"
                                  />
                                </Td>
                                <Td>
                                  <input
                                    type="text"
                                    defaultValue={item.unit}
                                    onChange={(event) =>
                                      handleUpMedInputChange(
                                        event,
                                        item.id,
                                        "unit",
                                      )
                                    }
                                    className="form-control"
                                  />
                                </Td>
                                <Td>
                                  <RxCross2
                                    onClick={() => removeUpMedicine(index)}
                                  />
                                </Td>
                              </Tr>
                            ))}

                          {isMedItem &&
                            tableMedData.map((item, index) => (
                              <Tr>
                                {/* <Td>{++index}</Td> */}
                                <Td>{item ? item.name : ""}</Td>
                                <Td>
                                  <input
                                    type="number"
                                    // defaultValue={procedure.qty}
                                    value={item.quantity}
                                    onChange={(event) =>
                                      handleMedInputChange(
                                        event,
                                        item.id,
                                        "quantity",
                                      )
                                    }
                                    className="form-control"
                                  />
                                </Td>
                                {/* <Td>{procedure.purchasePrice}</Td> */}
                                <Td>
                                  <input
                                    type="number"
                                    value={item.perUsageQTY}
                                    onChange={(event) =>
                                      handleMedInputChange(
                                        event,
                                        item.id,
                                        "perUsageQTY",
                                      )
                                    }
                                    className="form-control"
                                  />
                                </Td>
                                <Td>
                                  <input
                                    type="text"
                                    value={item.unit}
                                    onChange={(event) =>
                                      handleMedInputChange(
                                        event,
                                        item.id,
                                        "unit",
                                      )
                                    }
                                    className="form-control"
                                  />
                                </Td>
                                <Td>
                                  <RxCross2
                                    onClick={() => removeMedicine(item.item_id)}
                                  />
                                </Td>
                              </Tr>
                            ))}
                        </Tbody>
                      </Table>
                    </div>

                    {/* NOTE Procedure Medicine */}
                    <div className="col-6 form-group mt-3">
                      <Label>Procedure Medicine</Label>
                      <Typeahead
                        id="basic-typeahead-single"
                        labelKey="procedureItemName"
                        onChange={setProMedSelection}
                        options={procedures}
                        placeholder="Choose a procedure items..."
                        selected={proMedSelection}
                      />
                    </div>
                    <div className="col-3 mt-4">
                      <Button
                        onClick={(e) =>
                          handleProAddRow(
                            proMedSelection[0]._id,
                            proMedSelection[0].procedureItemName,
                          )
                        }
                      >
                        Add
                      </Button>
                    </div>
                    <div className="col-12 mt-4">
                      <Table className="table table-striped">
                        <Thead>
                          <Tr>
                            {/* <Th>No.</Th> */}
                            <Th>Item Name</Th>
                            <Th>Qty</Th>
                            {/* <Th>Purchase Price</Th> */}
                            <Th>Per Usage Qty</Th>
                            {/* <Th>Amount</Th> */}
                            <Th>Unit</Th>
                          </Tr>
                        </Thead>
                        {isItem && (
                          <Tbody>
                            {upProData &&
                              upProData.map((item, index) => (
                                <Tr>
                                  {/* <Td>{++index}</Td> */}
                                  <Td>{item.name}</Td>
                                  <Td>
                                    <input
                                      type="number"
                                      // defaultValue={procedure.qty}
                                      value={item.quantity}
                                      onChange={(event) =>
                                        handleUpProInputChange(
                                          event,
                                          item.id,
                                          "quantity",
                                        )
                                      }
                                      className="form-control"
                                    />
                                  </Td>
                                  {/* <Td>{procedure.purchasePrice}</Td> */}
                                  <Td>
                                    <input
                                      type="number"
                                      value={item.perUsageQTY}
                                      onChange={(event) =>
                                        handleUpProInputChange(
                                          event,
                                          item.id,
                                          "perUsageQTY",
                                        )
                                      }
                                      className="form-control"
                                    />
                                  </Td>

                                  <Td>
                                    <input
                                      type="text"
                                      // defaultValue={procedure.qty}
                                      defaultValue={item.unit}
                                      onChange={(event) =>
                                        handleUpProInputChange(
                                          event,
                                          item.id,
                                          "unit",
                                        )
                                      }
                                      className="form-control"
                                    />
                                  </Td>

                                  {/* <Td>{procedure.purchasePrice}</Td> */}
                                  <Td>
                                    <RxCross2
                                      onClick={(e) =>
                                        removeUpProcedure(item.item_id)
                                      }
                                    />
                                  </Td>
                                </Tr>
                              ))}
                            {tableProData.map((item, index) => (
                              <Tr>
                                {/* <Td></Td> */}
                                <Td>{item ? item.name : ""}</Td>
                                <Td>
                                  <input
                                    type="number"
                                    // defaultValue={procedure.qty}
                                    value={item.quantity}
                                    onChange={(event) =>
                                      handleProInputChange(
                                        event,
                                        item.id,
                                        "quantity",
                                      )
                                    }
                                    className="form-control"
                                  />
                                </Td>
                                {/* <Td>{procedure.purchasePrice}</Td> */}
                                <Td>
                                  <input
                                    type="number"
                                    value={item.perUsageQTY}
                                    onChange={(event) =>
                                      handleProInputChange(
                                        event,
                                        item.id,
                                        "perUsageQTY",
                                      )
                                    }
                                    className="form-control"
                                  />
                                </Td>
                                <Td>
                                  <input
                                    type="text"
                                    // defaultValue={procedure.qty}
                                    defaultValue={item.unit}
                                    onChange={(event) =>
                                      handleProInputChange(
                                        event,
                                        item.id,
                                        "unit",
                                      )
                                    }
                                    className="form-control"
                                  />
                                </Td>
                                <Td>
                                  <RxCross2
                                    onClick={() => removeProcedure(item.id)}
                                  />
                                </Td>
                              </Tr>
                            ))}
                          </Tbody>
                        )}
                      </Table>
                    </div>
                    {/* NOTE End Procedure Medicine */}

                    <div className="col-6 form-group mt-3">
                      <Label>Procedure Accessory</Label>
                      <Typeahead
                        id="basic-typeahead-single"
                        labelKey="accessoryItemName"
                        onChange={setAccSelection}
                        options={accessories}
                        placeholder="Choose a accessory items..."
                        selected={accSelection}
                      />
                    </div>
                    <div className="col-3 mt-4">
                      <Button
                        onClick={(e) =>
                          handleProAccAddRow(
                            accSelection[0]._id,
                            accSelection[0].accessoryItemName,
                          )
                        }
                      >
                        Add
                      </Button>
                    </div>
                    <div className="col-12 mt-3">
                      <Table className="table table-striped">
                        <Thead>
                          <Tr>
                            {/* <Th>No.</Th> */}
                            <Th>Item Name</Th>
                            <Th>Qty</Th>
                            {/* <Th>Purchase Price</Th> */}
                            <Th>Per Usage Qty</Th>
                            <Th>Unit</Th>
                          </Tr>
                        </Thead>
                        {isAccItem && (
                          <Tbody>
                            {upProAcc &&
                              upProAcc.map((item, index) => (
                                <Tr>
                                  {/* <Td>{++index}</Td> */}
                                  <Td>{item ? item.name : ""}</Td>
                                  <Td>
                                    <input
                                      type="number"
                                      // defaultValue={procedure.qty}
                                      value={item.quantity}
                                      onChange={(event) =>
                                        handleUpProAccInputChange(
                                          event,
                                          item.id,
                                          "quantity",
                                        )
                                      }
                                      className="form-control"
                                    />
                                  </Td>
                                  {/* <Td>{procedure.purchasePrice}</Td> */}
                                  <Td>
                                    <input
                                      type="number"
                                      value={item.perUsageQTY}
                                      onChange={(event) =>
                                        handleUpProAccInputChange(
                                          event,
                                          item.id,
                                          "perUsageQTY",
                                        )
                                      }
                                      className="form-control"
                                    />
                                  </Td>
                                  <Td>
                                    <input
                                      type="text"
                                      // defaultValue={procedure.qty}
                                      defaultValue={item.unit}
                                      onChange={(event) =>
                                        handleUpProAccInputChange(
                                          event,
                                          item.id,
                                          "unit",
                                        )
                                      }
                                      className="form-control"
                                    />
                                  </Td>

                                  <Td>
                                    <RxCross2
                                      onClick={() =>
                                        removeUpProAcc(item.item_id)
                                      }
                                    />
                                  </Td>
                                </Tr>
                              ))}

                            {tableProAccData.map((item, index) => (
                              <Tr>
                                {/* <Td></Td> */}
                                <Td>{item ? item.name : ""}</Td>
                                <Td>
                                  <input
                                    type="number"
                                    // defaultValue={procedure.qty}
                                    value={item.quantity}
                                    onChange={(event) =>
                                      handleProAccInputChange(
                                        event,
                                        item.id,
                                        "quantity",
                                      )
                                    }
                                    className="form-control"
                                  />
                                </Td>
                                {/* <Td>{procedure.purchasePrice}</Td> */}
                                <Td>
                                  <input
                                    type="number"
                                    value={item.perUsageQTY}
                                    onChange={(event) =>
                                      handleProAccInputChange(
                                        event,
                                        item.id,
                                        "perUsageQTY",
                                      )
                                    }
                                    className="form-control"
                                  />
                                </Td>
                                <Td>
                                  <input
                                    type="text"
                                    // defaultValue={procedure.qty}
                                    defaultValue={item.unit}
                                    onChange={(event) =>
                                      handleProAccInputChange(
                                        event,
                                        item.id,
                                        "unit",
                                      )
                                    }
                                    className="form-control"
                                  />
                                </Td>

                                <Td>
                                  <RxCross2
                                    onClick={() => removeProAcc(item.item_id)}
                                  />
                                </Td>
                              </Tr>
                            ))}
                          </Tbody>
                        )}
                      </Table>
                    </div>
                    {/* NOTE End Procedure Accessory */}

                    <div className="col-6 form-group mt-3">
                      <Label>General Items</Label>
                      <Typeahead
                        id="basic-typeahead-single"
                        labelKey="accessoryItemName"
                        onChange={setGeneralSelection}
                        options={generalList}
                        placeholder="Choose a accessory items..."
                        selected={generalSelection}
                      />
                    </div>
                    <div className="col-3 mt-4">
                      <Button
                        onClick={(e) =>
                          handleGeneralAddRow(
                            generalSelection[0]._id,
                            generalSelection[0].accessoryItemName ||
                              generalSelection[0].generalItemName,
                          )
                        }
                      >
                        Add
                      </Button>
                    </div>
                    <div className="col-12 mt-3">
                      <Table className="table table-striped">
                        <Thead>
                          <Tr>
                            {/* <Th>No.</Th> */}
                            <Th>Item Name</Th>
                            <Th>Qty</Th>
                            {/* <Th>Purchase Price</Th> */}
                            <Th>Per Usage Qty</Th>
                            <Th>Unit</Th>
                          </Tr>
                        </Thead>
                        {isGenItem && (
                          <Tbody>
                            {upGen &&
                              upGen.map((item, index) => (
                                <Tr>
                                  {/* <Td>{++index}</Td> */}
                                  <Td>{item ? item.name : ""}</Td>
                                  <Td>
                                    <input
                                      type="number"
                                      // defaultValue={procedure.qty}
                                      value={item.quantity}
                                      onChange={(event) =>
                                        handleUpGeneralInputChange(
                                          event,
                                          item.id,
                                          "quantity",
                                        )
                                      }
                                      className="form-control"
                                    />
                                  </Td>
                                  {/* <Td>{procedure.purchasePrice}</Td> */}
                                  <Td>
                                    <input
                                      type="number"
                                      value={item.perUsageQTY}
                                      onChange={(event) =>
                                        handleUpGeneralInputChange(
                                          event,
                                          item.id,
                                          "perUsageQTY",
                                        )
                                      }
                                      className="form-control"
                                    />
                                  </Td>
                                  <Td>
                                    <input
                                      type="text"
                                      // defaultValue={procedure.qty}
                                      defaultValue={item.unit}
                                      onChange={(event) =>
                                        handleUpGeneralInputChange(
                                          event,
                                          item.id,
                                          "unit",
                                        )
                                      }
                                      className="form-control"
                                    />
                                  </Td>

                                  <Td>
                                    <RxCross2
                                      onClick={() => removeUpGeneral(item.id)}
                                    />
                                  </Td>
                                </Tr>
                              ))}

                            {tableGenData.map((item, index) => (
                              <Tr>
                                {/* <Td></Td> */}
                                <Td>{item ? item.name : ""}</Td>
                                <Td>
                                  <input
                                    type="number"
                                    // defaultValue={procedure.qty}
                                    value={item.quantity}
                                    onChange={(event) =>
                                      handleGeneralInputChange(
                                        event,
                                        item.id,
                                        "quantity",
                                      )
                                    }
                                    className="form-control"
                                  />
                                </Td>
                                {/* <Td>{procedure.purchasePrice}</Td> */}
                                <Td>
                                  <input
                                    type="number"
                                    value={item.perUsageQTY}
                                    onChange={(event) =>
                                      handleGeneralInputChange(
                                        event,
                                        item.id,
                                        "perUsageQTY",
                                      )
                                    }
                                    className="form-control"
                                  />
                                </Td>
                                <Td>
                                  <input
                                    type="text"
                                    // defaultValue={procedure.qty}
                                    defaultValue={item.unit}
                                    onChange={(event) =>
                                      handleGeneralInputChange(
                                        event,
                                        item.id,
                                        "unit",
                                      )
                                    }
                                    className="form-control"
                                  />
                                </Td>

                                <Td>
                                  <RxCross2
                                    onClick={() => removeGeneral(item.item_id)}
                                  />
                                </Td>
                              </Tr>
                            ))}
                          </Tbody>
                        )}
                      </Table>
                    </div>

                    <div className="col-6 form-group mt-3">
                      <Label>Machine</Label>
                      <Typeahead
                        id="basic-typeahead-single"
                        labelKey="name"
                        onChange={setMachineSelection}
                        options={machines}
                        placeholder="Choose a machine items..."
                        selected={machineSelection}
                      />
                    </div>
                    <div className="col-3 mt-4">
                      <Button
                        onClick={(e) =>
                          handleMachineAddRow(
                            machineSelection[0]._id,
                            machineSelection[0].name,
                          )
                        }
                      >
                        Add
                      </Button>
                    </div>
                    <div className="col-12 mt-3">
                      <Table className="table table-striped">
                        <Thead>
                          <Tr>
                            {/* <Th>No.</Th> */}
                            <Th>Item Name</Th>
                            <Th>Qty</Th>
                            {/* <Th>Purchase Price</Th> */}
                            <Th>Per Usage Qty</Th>
                            <Th>Unit</Th>
                          </Tr>
                        </Thead>
                        {/* {isMacItem && (
                          <Tbody>
                            {upMachine &&
                              upMachine.map((macitem, index) =>
                                machines.map(
                                  (machine, i) =>
                                    macitem.item_id == machine._id && (
                                      <Tr>
                                        <Td>{machine.name}</Td>

                                        <Td>{machine.initialPrice}</Td>

                                        <Td>{machine.initialPrice}</Td>
                                        <Td>
                                          <RxCross2
                                            onClick={() =>
                                              removeMac(machine._id)
                                            }
                                          />
                                        </Td>
                                      </Tr>
                                    )
                                )
                              )}
                            {macitems.map((macitem, index) =>
                              machines.map(
                                (machine, i) =>
                                  macitem.item_id == machine._id && (
                                    <Tr>
                                      <Td>{machine.name}</Td>

                                      <Td>10</Td>

                                      <Td>1</Td>
                                      <Td>
                                        <RxCross2
                                          onClick={() => removeMac(machine._id)}
                                        />
                                      </Td>
                                    </Tr>
                                  )
                              )
                            )}
                          </Tbody>
                        )} */}
                        {isMacItem && (
                          <Tbody>
                            {upMachine &&
                              upMachine.map((item, index) => (
                                <Tr>
                                  {/* <Td>{++index}</Td> */}
                                  <Td>{item ? item.name : ""}</Td>
                                  <Td>
                                    <input
                                      type="number"
                                      // defaultValue={procedure.qty}
                                      value={item.quantity}
                                      onChange={(event) =>
                                        handleUpMachineInputChange(
                                          event,
                                          item.id,
                                          "quantity",
                                        )
                                      }
                                      className="form-control"
                                    />
                                  </Td>
                                  {/* <Td>{procedure.purchasePrice}</Td> */}
                                  <Td>
                                    <input
                                      type="number"
                                      value={item.perUsageQTY}
                                      onChange={(event) =>
                                        handleUpMachineInputChange(
                                          event,
                                          item.id,
                                          "perUsageQTY",
                                        )
                                      }
                                      className="form-control"
                                    />
                                  </Td>
                                  <Td>
                                    <input
                                      type="text"
                                      defaultValue={item.unit}
                                      onChange={(event) =>
                                        handleUpMachineInputChange(
                                          event,
                                          item.id,
                                          "unit",
                                        )
                                      }
                                      className="form-control"
                                    />
                                  </Td>

                                  <Td>
                                    <RxCross2
                                      onClick={() => removeUpMac(item.item_id)}
                                    />
                                  </Td>
                                </Tr>
                              ))}

                            {tableMachineData.map((item, index) => (
                              <Tr>
                                {/* <Td></Td> */}
                                <Td>{item ? item.name : ""}</Td>
                                <Td>
                                  <input
                                    type="number"
                                    // defaultValue={procedure.qty}
                                    value={item.quantity}
                                    onChange={(event) =>
                                      handleMachineInputChange(
                                        event,
                                        item.id,
                                        "quantity",
                                      )
                                    }
                                    className="form-control"
                                  />
                                </Td>
                                {/* <Td>{procedure.purchasePrice}</Td> */}
                                <Td>
                                  <input
                                    type="number"
                                    value={item.perUsageQTY}
                                    onChange={(event) =>
                                      handleMachineInputChange(
                                        event,
                                        item.id,
                                        "perUsageQTY",
                                      )
                                    }
                                    className="form-control"
                                  />
                                </Td>
                                <Td>
                                  <input
                                    type="text"
                                    defaultValue={item.unit}
                                    onChange={(event) =>
                                      handleMachineInputChange(
                                        event,
                                        item.id,
                                        "unit",
                                      )
                                    }
                                    className="form-control"
                                  />
                                </Td>

                                <Td>
                                  <RxCross2
                                    onClick={() => removeMac(item.id)}
                                  />
                                </Td>
                              </Tr>
                            ))}
                          </Tbody>
                        )}
                      </Table>
                    </div>
                    <div class="form-group">
                      <label for="name">Branch</label>
                      <select
                        class="custom-select border-info"
                        name="account_type_id"
                        onChange={(e) => handleBranch(e.target.value)}
                      >
                        <option hidden>Select Branch</option>

                        {branchList.map((option) => (
                          <option value={option._id}>{option.name}</option>
                        ))}
                      </select>
                    </div>

                    {showHO && (
                      <div className="row">
                        <div className="col-4 form-group mt-3">
                          <Label>Original Price</Label>
                          <Input
                            type="number"
                            className="form-control"
                            defaultValue={totalPrice}
                            onChange={(e) => setTotalPrice(e.target.value)}
                          />
                        </div>
                        <div className="col-2 form-group mt-3">
                          <Label>Percent(%)</Label>
                          <Input
                            type="number"
                            className="form-control"
                            defaultValue={percent}
                            onChange={(e) => handlePercent(e.target.value)}
                          />
                        </div>
                        <div className="col-4 form-group mt-3">
                          <Label>Selling Price</Label>
                          <Input
                            type="number"
                            className="form-control"
                            defaultValue={sellPrice}
                            onChange={(e) => setSellPrice(e.target.value)}
                          />
                        </div>
                      </div>
                    )}

                    {showPrice && (
                      <div className="row">
                        <div className="col-4 form-group mt-3">
                          <Label>TCL Total Price</Label>
                          <Input
                            type="number"
                            className="form-control"
                            defaultValue={TCLtotalPrice}
                            onChange={(e) => setTCLTotalPrice(e.target.value)}
                          />
                        </div>

                        <div className="col-4 form-group mt-3">
                          <Label>TCL Selling Price</Label>
                          <div className="input-group">
                            <Input
                              type="number"
                              className="form-control"
                              defaultValue={TCLsellPrice}
                              onChange={(e) => setTCLSellPrice(e.target.value)}
                            />
                            <div
                              className="input"
                              style={{ marginTop: "0.5em" }}
                            >
                              <span className="input-group-text">THB</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {showEight && (
                      <div className="row">
                        <div className="col-4 form-group mt-3">
                          <Label>8Mile Total Price</Label>
                          <Input
                            type="number"
                            className="form-control"
                            value={eightTotalPrice}
                            onChange={(e) => setEightTotalPrice(e.target.value)}
                          />
                        </div>

                        <div className="col-4 form-group mt-3">
                          <Label>8Mile Selling Price</Label>
                          <Input
                            type="number"
                            className="form-control"
                            defaultValue={eightSellPrice}
                            onChange={(e) => setEightSellPrice(e.target.value)}
                          />
                        </div>
                      </div>
                    )}
                    {showSC && (
                      <div className="row">
                        <div className="col-4 form-group mt-3">
                          <Label>Sanchaung Total Price</Label>
                          <Input
                            type="number"
                            className="form-control"
                            value={SCTotalPrice}
                            onChange={(e) => setSCTotalPrice(e.target.value)}
                          />
                        </div>

                        <div className="col-4 form-group mt-3">
                          <Label>Sanchaung Selling Price</Label>
                          <Input
                            type="number"
                            className="form-control"
                            defaultValue={SCSellPrice}
                            onChange={(e) => setSCSellPrice(e.target.value)}
                          />
                        </div>
                      </div>
                    )}
                    {showTgg && (
                      <div className="row">
                        <div className="col-4 form-group mt-3">
                          <Label>Thingangyun Total Price</Label>
                          <Input
                            type="number"
                            className="form-control"
                            value={TggTotalPrice}
                            onChange={(e) => setTggTotalPrice(e.target.value)}
                          />
                        </div>

                        <div className="col-4 form-group mt-3">
                          <Label>Thingangyun Selling Price</Label>
                          <Input
                            type="number"
                            className="form-control"
                            defaultValue={TggSellPrice}
                            onChange={(e) => setTggSellPrice(e.target.value)}
                          />
                        </div>
                      </div>
                    )}

                    {showNPT && (
                      <div className="row">
                        <div className="col-4 form-group mt-3">
                          <Label>NPT Total Price</Label>
                          <Input
                            type="number"
                            className="form-control"
                            defaultValue={NptTotalPrice}
                            onChange={(e) => setNptTotalPrice(e.target.value)}
                          />
                        </div>

                        <div className="col-4 form-group mt-3">
                          <Label>NPT Selling Price</Label>
                          <Input
                            type="number"
                            className="form-control"
                            defaultValue={NptSellPrice}
                            onChange={(e) => setNptSellPrice(e.target.value)}
                          />
                        </div>
                      </div>
                    )}
                    {showMDY && (
                      <div className="row">
                        <div className="col-4 form-group mt-3">
                          <Label>MDY Total Price</Label>
                          <Input
                            type="number"
                            className="form-control"
                            defaultValue={MDYTotalPrice}
                            onChange={(e) => setMDYTotalPrice(e.target.value)}
                          />
                        </div>

                        <div className="col-4 form-group mt-3">
                          <Label>MDY Selling Price</Label>
                          <Input
                            type="number"
                            className="form-control"
                            defaultValue={MDYSellPrice}
                            onChange={(e) => setMDYSellPrice(e.target.value)}
                          />
                        </div>
                      </div>
                    )}
                    {showLSH && (
                      <div className="row">
                        <div className="col-4 form-group mt-3">
                          <Label>LSH Total Price</Label>
                          <Input
                            type="number"
                            className="form-control"
                            defaultValue={LSHTotalPrice}
                            onChange={(e) => setLSHTotalPrice(e.target.value)}
                          />
                        </div>

                        <div className="col-4 form-group mt-3">
                          <Label>LSH Selling Price</Label>
                          <Input
                            type="number"
                            className="form-control"
                            defaultValue={LSHSellPrice}
                            onChange={(e) => setLSHSellPrice(e.target.value)}
                          />
                        </div>
                      </div>
                    )}
                    {showK && (
                      <div className="row">
                        <div className="col-4 form-group mt-3">
                          <Label>K Total Price</Label>
                          <Input
                            type="number"
                            className="form-control"
                            defaultValue={KTotalPrice}
                            onChange={(e) => setKTotalPrice(e.target.value)}
                          />
                        </div>

                        <div className="col-4 form-group mt-3">
                          <Label>K Selling Price</Label>
                          <Input
                            type="number"
                            className="form-control"
                            defaultValue={KSellPrice}
                            onChange={(e) => setKSellPrice(e.target.value)}
                          />
                        </div>
                      </div>
                    )}
                    {showLMD && (
                      <div className="row">
                        <div className="col-4 form-group mt-3">
                          <Label>LMD Total Price</Label>
                          <Input
                            type="number"
                            className="form-control"
                            defaultValue={LMDtotalPrice}
                            onChange={(e) => setLMDTotalPrice(e.target.value)}
                          />
                        </div>

                        <div className="col-4 form-group mt-3">
                          <Label>LMD Selling Price</Label>
                          <Input
                            type="number"
                            className="form-control"
                            defaultValue={LMDsellPrice}
                            onChange={(e) => setLMDSellPrice(e.target.value)}
                          />
                        </div>
                      </div>
                    )}
                    <div className="col-6 form-group mt-3">
                      <Label>Description</Label>
                      <Textarea
                        className="form-control"
                        defaultValue={description}
                        onChange={(e) => setDescription(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
                <Top>
                  <Center>
                    <Button onClick={update}>Update</Button>
                  </Center>
                </Top>
              </div>
            </div>
          </section>
        </div>

    </>
  );
};

export default Update2;
